// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import store from "./store/";
import router from "./router";
import VueI18n from "vue-i18n";
import VueMq from 'vue-mq';
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, numeric, email, max_value, min_value } from 'vee-validate/dist/rules';
import SvgIcon from "@/components/SvgIcon";

import { defaultLocale, languages } from "./locales/index.js";

Vue.config.productionTip = false;

Vue.use(VueI18n);

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    mobile: 800,
    desktop: Infinity,
  },
  defaultBreakpoint: 'desktop' // customize this for SSR
})

const messages = Object.assign(languages);

export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: "fr",
  messages
});

extend("required", {
  ...required,
  message: "Ce champs est requis"
});

extend("numeric", {
  ...numeric,
  message: "Seuls les chiffres sont autorisés"
});

extend("min_value", {
  ...min_value,
  message: "Vous avez dépassé la valeur minimale"
});

extend("max_value", {
  ...max_value,
  message: "Vous avez dépassé la valeur maximale"
});

extend("email", {
  ...email,
  message: "L'adresse mail n'est pas valide"
});

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("SvgIcon", SvgIcon);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js